module.exports = __webpack_public_path__ + "media/assets/good_at/linux-fffc21d61efd669c42f38347398bd0c2.png";